import React from "react"

interface AddressAutoCompleteFieldProps {
  name: string
  placeholder: string
  required?: boolean
  options: string[]
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
}

const AddressAutoCompleteField: React.FC<AddressAutoCompleteFieldProps> = ({
  name,
  placeholder,
  required = false,
  options,
  value,
  onChange,
}) => {
  const ringHighlight = value.length > 0 ? "ring-2 ring-nelo-blue border-transparent bg-nelo-sky-50" : "bg-white"
  const textColor = value.length > 0 ? "text-ui-fg-base" : "text-gray-400"
  const combinedClass = `w-full p-3 border border-nelo-dark-gray rounded-lg font-nunito focus:outline-none focus:ring-2 focus:ring-nelo-blue focus:border-transparent ${ringHighlight} ${textColor}`

  if (options.length > 1) {
    return (
      <select name={name} required={required} value={value} className={combinedClass} onChange={onChange}>
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    )
  } else {
    return (
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        required={required}
        value={value}
        className={combinedClass}
        onChange={onChange}
      />
    )
  }
}

export default AddressAutoCompleteField
